import { days } from 'common/utils/dates'
import OpenGraph from 'components/OpenGraph'
import { BlockLoader } from 'cc/Loader'
import { getMostReviewedDomains, getDomainReviewCounts } from 'utils/hooks'
import Link from 'components/Link'
import routes from 'common/routes'

import DomainLogo from 'components/DomainLogo'
import VoteArrowOverview from 'cc/VoteArrowOverview'

// TODO: is this correct?
import { firestore } from 'lib/server/firebase'

const DomainCard = ({ domainKey, domain, reviewCounts, domainTags }) => {
  return (
    <Link href={routes.sitePath(domainKey)}>
      <div className="flex flex-wrap justify-between items-center rounded-md border-4 my-4 lg:w-2/3 mx-auto bg-gradient-to-r from-gray-200 to-gray-100 hover:border-gray-300">
        <div className="p-4 flex flex-col space-y-2">
          <DomainLogo domainKey={domainKey} domain={domain} size={128} />
          <div className="text-3xl font-serif text-gray-700 font-thin">
            {domainKey}
          </div>
        </div>
        <div className="mx-10">
          <VoteArrowOverview
            reviewCounts={reviewCounts}
            className="inline-flex space-x-4 py-4 scale-125"
          />
        </div>
      </div>
    </Link>
  )
}

const SitesPage = ({ mostReviewed, reviewCountsByDomainKey }) => {
  return (
    <>
      <OpenGraph
        url={routes.sitesUrl}
        title="Most Reviewed Sites"
        // TODO: description
      />
      {mostReviewed?.length ? (
        <div className="container">
          {mostReviewed.map((domain) => (
            <DomainCard
              key={domain.id}
              domain={domain}
              domainKey={domain.id}
              reviewCounts={reviewCountsByDomainKey[domain.id] || {}}
            />
          ))}
        </div>
      ) : (
        <BlockLoader />
      )}
    </>
  )
}

SitesPage.title = 'Top 25 Most Viewed Sites'
SitesPage.domainLogos = true

export async function getStaticProps() {
  const mostReviewed = await getMostReviewedDomains()
  const reviewCountsByDomainKey = {}

  await Promise.all(
    mostReviewed.map(async ({ id: domainKey }) => {
      reviewCountsByDomainKey[domainKey] = await getDomainReviewCounts(
        domainKey,
        firestore,
      )
    }),
  )

  return {
    props: { mostReviewed, reviewCountsByDomainKey },
    revalidate: 1 * days,
  }
}

export default SitesPage
